import React from 'react'
import UserWidget8 from './UserWidget8'
import users from '../json/users.json'

const SampleUserWidget8 = () => <UserWidget8 users={users} amount={10} />

export default SampleUserWidget8
